/*
 * rheincool — Technische Daten: angeschnitten statt zugeklappt
 *
 * <rc-spec-expand> deckelt die Tabelle auf eine feste Hoehe und blendet
 * darunter einen Knopf ein. Der Deckel sitzt im CSS, das Modul setzt nur
 * `data-offen` und `aria-expanded` um.
 *
 * Warum nicht das vorhandene rc-accordion: das klappt ganz auf oder ganz zu.
 * Die Tabelle stand hier schon einmal hinter einem Knopf und wurde bewusst
 * geoeffnet, weil Masse und Gewichte im Auslieferzustand unsichtbar waren —
 * fuer Kunden wie fuer Suchmaschinen. Angeschnitten loest beides: die ersten
 * Zeilen stehen sofort da, der Rest bleibt im DOM und ist ueber den
 * Scrollbereich schon vor dem Aufklappen erreichbar.
 *
 * Ohne JavaScript bleibt die Tabelle angeschnitten und scrollbar — der Knopf
 * wird erst vom Modul sichtbar geschaltet, damit er nicht ohne Funktion
 * herumsteht.
 */
if (!customElements.get('rc-spec-expand')) {
class RcSpecExpand extends HTMLElement {
  connectedCallback() {
    this.knopf = this.querySelector('[data-spec-toggle]');
    this.rahmen = this.querySelector('[data-spec-panel]');
    if (!this.knopf || !this.rahmen) return;

    // Deckel nur setzen, wenn es ueberhaupt etwas zu verdecken gibt.
    if (this.rahmen.scrollHeight <= this.rahmen.clientHeight + 8) {
      // `data-offen` nimmt den Deckel im CSS weg; die Hausregel verbietet
      // Inline-Styles, und `overflow: visible` wuerde hier ausserdem die
      // gestreiften Zeilen ueber die abgerundeten Ecken laufen lassen.
      this.knopf.hidden = true;
      this.setAttribute('data-offen', '');
      this.rahmen.removeAttribute('tabindex');
      this.rahmen.removeAttribute('role');
      return;
    }

    this.knopf.hidden = false;
    this.knopf.addEventListener('click', () => this.umschalten());
  }

  umschalten() {
    const offen = this.hasAttribute('data-offen');
    if (offen) {
      this.removeAttribute('data-offen');
      // Beim Zuklappen an den Anfang der Tabelle zurueck, sonst steht der
      // Nutzer im Nichts: der Scrollbereich behaelt sonst seine Position,
      // und sichtbar waeren dann Zeilen aus der Mitte ohne Anfang.
      this.rahmen.scrollTop = 0;
      const oben = this.getBoundingClientRect().top;
      if (oben < 0) this.scrollIntoView({ block: 'start', behavior: this.weich() });
      // Aufgeklappt ist der Bereich wieder scrollbar — Tab-Stopp zurueck.
      this.rahmen.setAttribute('tabindex', '0');
      this.rahmen.setAttribute('role', 'region');
    } else {
      this.setAttribute('data-offen', '');
      // Offen steht der Rahmen auf `overflow: hidden`, es gibt nichts mehr zu
      // scrollen. Ein Tab-Stopp ohne Scrollbalken waere dann eine Station im
      // Tastaturlauf, an der nichts passiert.
      this.rahmen.removeAttribute('tabindex');
      this.rahmen.removeAttribute('role');
    }
    this.knopf.setAttribute('aria-expanded', String(!offen));
    const label = this.knopf.querySelector('[data-spec-label]');
    if (label) label.textContent = offen ? this.knopf.dataset.mehr : this.knopf.dataset.weniger;
  }

  weich() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }
}
customElements.define('rc-spec-expand', RcSpecExpand);
}
